import { combineReducers } from "@reduxjs/toolkit";
import UserSlice from "./userSlice";
import EventsSlice from "./eventsSlice";
const Slices = combineReducers({
  User: UserSlice,
  Events: EventsSlice,
});
export default Slices;
